// 映射及计算
export const loading = state => state.loading
export const pageHover = state=> state.pageHover

export const currentIndex = state => state.currentIndex
export const playing = state=> state.playing
export const fullScreen = state=> state.fullScreen
export const audioPlayList = state=> state.audioPlayList
export const sequenceList = state=> state.sequenceList
export const mode = state=> state.mode

export const currentAudioPlayMedia = (state) => {
    let list = state.audioPlayList || [];
    let index=state.currentIndex;
    if(index != -1){
        return list[index]
    }else{
        return {};
    }

}


// WEBPACK FOOTER //
// ./src/store/getters.js